import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const spinnerVariants = {
  animate: {
    rotate: 360,
    transition: {
      repeat: Infinity,
      duration: 1,
      ease: 'linear' as const, // ✅ Type-safe easing
    },
  },
};

const pulseVariants = {
  animate: {
    scale: [1, 1.05, 1],
    transition: {
      repeat: Infinity,
      duration: 1.5,
      ease: 'easeInOut' as const, // ✅ Type-safe easing
    },
  },
};

interface CustomLoadingProps {
  message?: string;
}

const CustomLoading: React.FC<CustomLoadingProps> = ({ message = 'Loading...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        textAlign: 'center',
      }}
    >
      {/* ✨ Gradient Spinner */}
      <motion.div
        variants={spinnerVariants}
        animate="animate"
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: '5px solid transparent',
          borderTop: '5px solid #0d2c5a',
          borderRight: '5px solid #1976d2',
          borderLeft: '5px solid #64b5f6',
          boxShadow: '0 0 15px rgba(33,150,243,0.5)',
        }}
      />

      {/* 💫 Animated Loading Text */}
      <motion.div
        variants={pulseVariants}
        animate="animate"
        style={{ marginTop: 20 }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            letterSpacing: '0.5px',
            background: 'linear-gradient(90deg, #0d2c5a, #1976d2, #64b5f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {message}
        </Typography>
      </motion.div>
    </Box>
  );
};

export default CustomLoading;
